import { EducationServiceVacation, VacationStatus } from '@crm/shared/persons/types';

export function getVacationStatus(vacation: EducationServiceVacation | null): VacationStatus {
  if (vacation === null) {
    return VacationStatus.notPlanned;
  }

  return vacation.state;
}
